import { Form, Modal } from 'antd'
import Avatar from 'components/Avatar'
import Button from 'components/Button/index'
import Control from 'components/Control/Control'
import Flex from 'components/Flex'
import Party from 'components/Images/party.png'
import Input from 'components/Input/input'
import Label from 'components/Label/Label'
import AntdSelect from 'components/Select'
import CheckCircleIcon from 'components/icons/CheckCircleIcon'
import Emptystates from 'components/icons/Emptystates.svg'
import {
  Content,
  DisplayPad,
  FormItem,
  InputGroup,
  Learn,
  MailHeading,
  MailSubHeading,
  OTPButton,
  OTPHeading,
  OTPMessage,
  RowPadding,
  Span,
  SpanBold,
  SplitFlex,
  StyledB,
  StyledInput,
  StyledInputDiv,
  StyledSelectDiv,
} from 'modules/ManageProfile/Components/PhoneModel/style'
import React, { useEffect, useState } from 'react'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { OTPElement } from './style'
const ChangePhoneNum = ({
  phoneModel,
  phoneOTP,
  phoneVerify,
  setPhoneModel,
  setPhoneOTP,
  onPhoneEntered,
  enteredPhone,
  setPhoneVerify,
  SendOtp,
  checkOtp,
  getUserInfo,
  setenteredPhone,
  countryCodeList,
  setCountryCodeSearch,
  userData,
}) => {
  const [countryCode, setCountryCode] = useState('+91')
  const [errmsg, setErrmsg] = useState('')
  const [form] = Form.useForm()
  const [otpSMS, setOtpSMS] = useState({
    otp1: '',
    otp2: '',
    otp3: '',
    otp4: '',
  })

  useEffect(() => {
    getUserInfo()
  }, [])

  useEffect(() => {
    form.setFieldsValue({
      country_code: userData?.country_code,
    })
  }, [userData])

  useEffect(() => {
    if (otpSMS?.otp1 && otpSMS?.otp2 && otpSMS?.otp3 && otpSMS?.otp4) {
      otpSMSCheck()
    }
  }, [otpSMS])

  const clickEventSMS = (position, e) => {
    if (position !== 'last' && e.target.value) {
      document.getElementById(position).focus()
    }
    if (position === 'sec') {
      setOtpSMS({ ...otpSMS, otp1: e.target.value })
    } else if (position === 'third') {
      setOtpSMS({ ...otpSMS, otp2: e.target.value })
    } else if (position === 'fourth') {
      setOtpSMS({ ...otpSMS, otp3: e.target.value })
    } else {
      setOtpSMS({ ...otpSMS, otp4: e.target.value })
    }
  }

  const otpSMSCheck = async () => {
    let otpNum = `${otpSMS?.otp1}${otpSMS?.otp2}${otpSMS?.otp3}${otpSMS?.otp4}`

    let payLoad = {
      otp: otpNum,
      newPhoneNumber: enteredPhone,
      country_code: countryCode,
    }
    let respo = await checkOtp(payLoad);
    if (respo?.data?.message?.success === true) {
      setPhoneVerify(true)
      setPhoneOTP(false)
      setErrmsg('')
    } else {
      respo?.message?.message
        ? setErrmsg(respo?.message?.message)
        : setErrmsg('Incorrect OTP')
    }
  }

  const handlePhoneVerifyCancel = () => {
    setPhoneVerify(false)
    getUserInfo()
  }

  const sendPhoneOTP = value => {
    let payLoad = {
      newPhone: enteredPhone,
      newEmail: '',
      country_code: value?.country_code,
    }
    setCountryCode(value?.country_code)
    SendOtp(payLoad)
    setPhoneModel(false)
    setPhoneOTP(true)
  }

  const handlePhoneCancel = () => {
    setenteredPhone()
    setPhoneModel(false)
  }
  const handlePhoneOTPCancel = () => {
    setOtpSMS({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    })
    setenteredPhone()
    setPhoneOTP(false)
  }

  const resendOtp = async () => {
    let payLoad = {
      newPhone: enteredPhone,
      newEmail: '',
      country_code: countryCode,
    }
    let otpresp = await SendOtp(payLoad)

    if (otpresp?.status >= 200 && otpresp?.status <= 300) {
      SuccessMessage('OTP Sent Successfully')
    } else {
      ErrorMessage(otpresp?.message)
    }
  }
  const onChnageSendOtpSMS = async () => {
    setOtpSMS({
      otp1: '',
      otp2: '',
      otp3: '',
      otp4: '',
    })

    setErrmsg('')
  }

  return (
    <>
      <Modal
        width={'585px'}
        open={phoneModel}
        footer={null}
        onCancel={handlePhoneCancel}
      >
        <RowPadding>
          <Content alignCenter column center>
            <Flex>
              <img src={Emptystates} alt={'emptyState'} />
            </Flex>
            <MailHeading>Update Your Phone Number</MailHeading>
            <MailSubHeading>
              You have to <b>Verify</b> your phone number to Login further *
            </MailSubHeading>
          </Content>
          <Form
            style={{ width: '100%' }}
            scrollToFirstError
            onFinish={sendPhoneOTP}
            id={'phoneForm'}
            layout="vertical"
            form={form}
          >
            <Label>Phone Address *</Label>
            <Control>
              <StyledSelectDiv>
                <FormItem
                  name="country_code"
                  width={'100%'}
                  rule={[
                    {
                      required: true,
                      message: 'Required',
                    },
                  ]}
                >
                  <AntdSelect
                    showSearch
                    width="100%"
                    OptionData={countryCodeList}
                    nameParam="phone_code"
                    valueParam="phone_code"
                    bordered={false}
                    placeholder="91"
                    onSearch={value => setCountryCodeSearch(value)}
                    onSelect={() => setCountryCodeSearch('')}
                    filterOption={false}
                  />
                </FormItem>
              </StyledSelectDiv>
              <StyledInputDiv>
                <StyledInput
                  width="100%"
                  type="number"
                  placeholder="Eg: 1010101010"
                  name="Phone"
                  rules={[
                    {
                      required: true,
                      message: 'Please Enter phone number!',
                    },
                    {
                      min: 10,
                      max: 10,
                      message: 'Please enter valid phone number',
                    },
                  ]}
                  onChange={onPhoneEntered}
                />
              </StyledInputDiv>
            </Control>
            <DisplayPad>
              <Button.Primary
                htmlType="submit"
                text={'Send Verification Code'}
                width={'100%'}
                padding={'10px'}
              />
            </DisplayPad>
          </Form>
          <MailSubHeading>
            You will receive an OTP to your phone number to verify your phone
            number.{' '}
          </MailSubHeading>

          <SplitFlex row spaceBetween alignCenter>
            <Flex flexStart>
              <Learn href={'http://pluginlive.com'} target="_blank">
                Learn More
              </Learn>
            </Flex>
            <MailSubHeading>*Terms and condition applied</MailSubHeading>
          </SplitFlex>
        </RowPadding>
      </Modal>
      <Modal
        width={'585px'}
        open={phoneOTP}
        footer={null}
        onFinish={sendPhoneOTP}
        onCancel={handlePhoneOTPCancel}
        afterClose={handlePhoneOTPCancel}
      >
        <RowPadding>
          <Content alignCenter column center>
            <Flex>
              <img src={Emptystates} alt="emptyStates" />
            </Flex>
            <MailHeading>Verify your Phone Number </MailHeading>
          </Content>

          <MailSubHeading>
            We will send you a 4-digit ‘One Time Password’ to your phone number
            . Please verify it to proceed further.
          </MailSubHeading>
          <DisplayPad>
            <MailSubHeading>
              A verification code will be sent to
              <StyledB>{enteredPhone}</StyledB>
            </MailSubHeading>
          </DisplayPad>
          <OTPElement alignCenter column>
            <OTPHeading>Enter the OTP</OTPHeading>
            <InputGroup>
              <Input
                placeholder="0"
                width="50px"
                type="number"
                padding="19px"
                id="1st"
                maxLength={1}
                onChange={e => clickEventSMS('sec', e)}
                value={otpSMS?.otp1}
              />
              <Input
                placeholder="0"
                type="number"
                id="sec"
                width="50px"
                padding="19px"
                maxLength={1}
                onChange={e => clickEventSMS('third', e)}
                value={otpSMS?.otp2}
              />
              <Input
                placeholder="0"
                width="50px"
                type="number"
                padding="19px"
                id="third"
                maxLength={1}
                onChange={e => clickEventSMS('fourth', e)}
                value={otpSMS?.otp3}
              />
              <Input
                placeholder="0"
                id="fourth"
                width="50px"
                padding="19px"
                type="number"
                maxLength={1}
                onChange={e => clickEventSMS('last', e)}
                value={otpSMS?.otp4}
              />
            </InputGroup>
            <Span>{errmsg}</Span>
            <OTPButton onClick={() => onChnageSendOtpSMS()}>
              Didn’t receive? &nbsp;
              <SpanBold onClick={resendOtp}>Resend OTP</SpanBold>
            </OTPButton>
            {!otpSMS?.otp4 && (
              <OTPMessage>
                <div>
                  <CheckCircleIcon />
                </div>
                <div>OTP Sent Successfully.</div>
              </OTPMessage>
            )}
          </OTPElement>
        </RowPadding>
      </Modal>

      <Modal
        width={'585px'}
        open={phoneVerify}
        footer={null}
        onCancel={handlePhoneVerifyCancel}
      >
        <RowPadding>
          <Content alignCenter column center>
            <Flex>
              <Avatar src={Party} size={50} shape={'square'} />
            </Flex>
            <MailHeading>Verified Successfully</MailHeading>
            <MailSubHeading>
              Your mobile number verified successfully.
            </MailSubHeading>
          </Content>
        </RowPadding>
      </Modal>
    </>
  )
}

export default ChangePhoneNum
